import React, { createContext, useContext, ReactNode } from 'react';
import { IFoundationProgramDetailsContextModel, IFoundationProgramFilesContextModel } from './foundationProgramModels';

// Details Context
const ProgramDetailsContext = createContext<IFoundationProgramDetailsContextModel | undefined>(undefined);

export const ProgramDetailsProvider: React.FC<{ value: IFoundationProgramDetailsContextModel; children: ReactNode }> = ({
    value,
    children,
}) => (
    <ProgramDetailsContext.Provider value={value}>{children}</ProgramDetailsContext.Provider>
);

export const useProgramDetailsContext = () => {
    const context = useContext(ProgramDetailsContext);
    if (!context) {
        throw new Error('useProgramDetailsContext must be used within a ProgramDetailsProvider');
    }
    return context;
};

// Files Context
const ProgramFilesContext = createContext<IFoundationProgramFilesContextModel | undefined>(undefined);

export const ProgramFilesProvider: React.FC<{ value: IFoundationProgramFilesContextModel; children: ReactNode }> = ({
    value,
    children,
}) => (
    <ProgramFilesContext.Provider value={value}>{children}</ProgramFilesContext.Provider>
);

export const useProgramFilesContext = () => {
    const context = useContext(ProgramFilesContext);
    if (!context) {
        throw new Error('useProgramFilesContext must be used within a ProgramFilesProvider');
    }
    return context;
};
